import { PERSONNELS_SOURCE_URL } from "@/constants";
import {
  UserOpsProps,
  UsersField,
} from "@/pages/requests/components/users/types";
import { selectRequestFormStore, useBoundStore } from "@/services/stores";
import { compact, filter, map } from "lodash";
import { ChangeEvent, useCallback, useState } from "react";
import { Person } from "@/services";

export const useUsersOps = ({ data, onSelectUser }: UserOpsProps) => {
  const { requestFormData, setRequestFormData } = useBoundStore(
    selectRequestFormStore,
  );

  const [isSelectedAll, toggleSelectAll] = useState(false);
  const [isOpenModalUser, toggleOpenModal] = useState<Person | null>(null);

  const handleToggleUserModal = (user: Person | null) => {
    toggleOpenModal(user);
  };

  const handleToggleSelectUser = useCallback(
    (item: Person, isChecked: boolean) => {
      const selectedUsers = requestFormData?.[UsersField.Users] as Person[];

      if (!item.WorkerOnboardingStatus) {
        return;
      }

      const users = isChecked
        ? selectedUsers
          ? [...selectedUsers, item]
          : [item]
        : filter(
            selectedUsers,
            user => user.WorkerEidUnifiedNumber !== item.WorkerEidUnifiedNumber,
          );

      if (onSelectUser) {
        onSelectUser(users, UsersField.Users);
      }

      setRequestFormData(UsersField.Users, users);
    },
    [onSelectUser, requestFormData, setRequestFormData],
  );

  const handleToggleAll = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const isNotChecked = !e.target.checked;

      // TODO Fix me
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      const users: Person[] | [] = isNotChecked
        ? []
        : compact(
            map(
              filter(data, (user: Person) => user.WorkerOnboardingStatus),
              (user: Person) => ({
                ...user,
                Value: user.WorkerEidUnifiedNumber, // TODO defaultFilterValue
              }),
            ),
          );

      toggleSelectAll(isNotChecked);

      if (onSelectUser) {
        onSelectUser(users, UsersField.Users);
      }

      setRequestFormData(UsersField.Users, users);
    },
    [data, onSelectUser, setRequestFormData],
  );

  const handleUpdatePersonnel = useCallback(() => {
    window.open(PERSONNELS_SOURCE_URL, "_blank");
  }, []);

  return {
    isSelectedAll,
    isOpenModalUser,
    onToggleUserModal: handleToggleUserModal,
    onToggleSelectUser: handleToggleSelectUser,
    onToggleAll: handleToggleAll,
    onUpdatePersonnel: handleUpdatePersonnel,
  };
};
